import { http } from '../services';

class AvaliadoresAreasService {
    avaliadoresAreasForm() {
        return http.get('/avaliadoresareas/form');
    }

    async getAvaliadoresAreas(projeto) {
        return http.get('/avaliadoresareas', {
            projeto,
        });
    }

    update(avaliadorArea) {
        return http.put('/avaliadoresareas', avaliadorArea);
    }
}

const avaliadoresAreasService = new AvaliadoresAreasService();
export default avaliadoresAreasService;
